<template>
  <div class="shop">
    <div class="top">
      <el-button size="small" type="primary" @click="exportWoods"
        >导出数据</el-button
      >

      <el-button
        style="float:right"
        class="search"
        size="small"
        type="primary"
        @click="searchList"
        >搜索</el-button
      >
      <el-input
        style="float:right"
        class="search input"
        size="small"
        v-model="serchMobile"
        placeholder="输入手机号查询"
        clearable
      ></el-input>
      <el-button
        size="small"
        style="margin-left:10px;margin-bottom:20px"
        type="primary"
        @click="addItem"
        >添加</el-button
      >
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="id"></el-table-column>
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="手机号" prop="mobile"></el-table-column>
      <el-table-column label="累计收款" prop="all_money"></el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="editItem(scope.row)">编辑</el-button>
          <el-button size="mini" @click="toCardList(scope.row)"
            >查看卡</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!--添加弹窗-->
    <jdialog title="添加" :visible.sync="isShowAddWindow" width="640px">
      <el-form
        :model="addWindowInfo"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <el-form-item label="姓名">
          <el-input
            type="text"
            placeholder="姓名"
            v-model="addWindowInfo.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            type="tel"
            maxlength="11"
            placeholder="手机号"
            v-model="addWindowInfo.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="text"
            placeholder="备注"
            v-model="addWindowInfo.remarks"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowAddWindow = false">取消</el-button>
        <el-button size="mini" type="primary" @click="creatAdd">确定</el-button>
      </div>
    </jdialog>
    <!--编辑弹窗-->
    <jdialog title="编辑" :visible.sync="isShowEditWindow" width="640px">
      <el-form
        :model="windowInfo"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <el-form-item label="姓名">
          <el-input
            type="text"
            placeholder="姓名"
            v-model="windowInfo.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            readonly
            type="tel"
            maxlength="11"
            placeholder="手机号"
            v-model="windowInfo.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="tel"
            placeholder="备注"
            v-model="windowInfo.remarks"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowEditWindow = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click="creatEdit"
          >确定</el-button
        >
      </div>
    </jdialog>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { getBcList, bcAddEdit } from '@/api/redpacketManage'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      serchMobile: '', // 搜索手机号
      tableData: [],
      labelPosition: 'right',
      isShowAddWindow: false,
      isShowEditWindow: false,
      is_export: 0, //0非导出，1导出
      form: {
        page: 1
      },
      total: 0,
      addWindowInfo: {
        name: '',
        mobile: '',
        remarks: ''
      },
      windowInfo: {
        id: '',
        name: '',
        remarks: ''
      },
      btnFlag: true
    }
  },
  mounted() {
    this.getBcList()
  },
  methods: {
    //获取列表数据
    async getBcList() {
      let is_export = this.is_export
      let serchMobile = this.serchMobile
      let url = `page=${
        this.form.page
      }&is_export=${is_export}&mobile=${serchMobile}`
      let res = await getBcList(url)
      console.log(res)
      if (res.code === 10000) {
        if (this.is_export == 1) {
          this.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          )
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.is_export = 0
        this.$message.error(res.message)
      }
    },
    //导出
    exportWoods() {
      this.is_export = 1
      this.getBcList()
    },
    //搜索
    searchList() {
      this.is_export = 0
      this.form.page = 1
      this.getBcList()
    },
    // 跳转查看卡
    toCardList(info) {
      let id = info.id
      this.$router.push({
        path: './lookBcCard',
        query: { saler_id: id }
      })
    },
    //显示添加弹窗
    addItem() {
      this.addWindowInfo.name = ''
      this.addWindowInfo.mobile = ''
      this.addWindowInfo.remarks = ''
      this.isShowAddWindow = true
    },
    //显示编辑弹窗
    editItem(info) {
      this.windowInfo.id = info.id
      this.windowInfo.mobile = info.mobile
      this.windowInfo.name = info.name
      this.windowInfo.remarks = info.remarks
      this.isShowEditWindow = true
    },
    //确认添加
    async creatAdd() {
      let btnFlag = this.btnFlag
      if (btnFlag) {
        this.btnFlag = false
        let res = await bcAddEdit(this.addWindowInfo)
        if (res.code === 10000) {
          this.getBcList()
          this.$message.success(res.message)
          this.isShowAddWindow = false
          this.btnFlag = true
        } else {
          this.$message.error(res.message)
          this.btnFlag = true
        }
      }
    },
    //确认编辑
    async creatEdit() {
      let btnFlag = this.btnFlag
      if (btnFlag) {
        this.btnFlag = false
        let res = await bcAddEdit(this.windowInfo)
        if (res.code === 10000) {
          this.getBcList()
          this.isShowEditWindow = false
          this.$message.success(res.message)
          this.btnFlag = true
        } else {
          this.$message.error(res.message)
          this.btnFlag = true
        }
      }
    },
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getBcList()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top .input {
    width: 150px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
